interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const getSchema = (): Record<string, unknown> => {
    const base = { '@context': 'https://schema.org', '@type': type };

    switch (type) {
      case 'Organization':
        return {
          ...base,
          name: '黑料爆料',
          url: 'https://heiliaobaoliao.com',
          description: '汇聚网络热议猛料，涵盖娱乐圈、网红、明星等各领域内幕信息，实时更新独家爆料内容。',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'tips@heiliaobaoliao.com',
            contactType: '爆料投稿',
          },
        };

      case 'WebSite':
        return {
          ...base,
          name: '黑料爆料',
          url: 'https://heiliaobaoliao.com',
          description: '汇聚网络热议猛料，涵盖娱乐圈、网红、明星等各领域内幕信息。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://heiliaobaoliao.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        };

      case 'WebPage':
        return {
          ...base,
          ...data,
        };

      default:
        return base;
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getSchema()) }}
    />
  );
}